import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CustomersAutomationConfig } from "./automationConfigApi";
import { getCustomersConfig, updateCustomersConfig } from "./automationConfigApi";

const queryKey = ["automation-settings", "customers"];

export const useCustomerAutomationConfig = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: ({ signal }) => getCustomersConfig(signal),
  });

  const updateMutation = useMutation<CustomersAutomationConfig, unknown, CustomersAutomationConfig>({
    mutationFn: (v) => updateCustomersConfig(v),
    onSuccess: async (data) => {
      enqueueSnackbar("Ustawienia dla klientów zostały zaktualizowane", { variant: "success" });
      queryClient.setQueryData(queryKey, data);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zaktualizować ustawień dla klientów. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return { isLoading, data, updateSettings: (config: CustomersAutomationConfig) => updateMutation.mutateAsync(config) };
};
